import { render, staticRenderFns } from "./CardWorkspace.vue?vue&type=template&id=2d0e13a6"
import script from "./CardWorkspace.vue?vue&type=script&lang=js"
export * from "./CardWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports